
import { i18nGlobal } from '@/i18n'
import { safeToStringLocal } from '@/utils/loggerLocal'
import { DBRetCode } from '@functions/models/DBEnum'
import { type IntError } from '@functions/models/interfaces/intError'


export const ERROR_MESSAGE_DELAY = 7000

/*
export interface ErrorState {
    error: string;
    techInfo: string;
    type: DBRetCode
}*/

export interface ErrorState {
  message: string
  techInfo: string
  type: DBRetCode
}

export const useStoreError = defineStore( 'error', {
  state: (): ErrorState => {
    return {
      message: '',
      techInfo: '',
      type: DBRetCode.SUCCESS,
    }
  },
  actions: {
    displayMsg ( msg: string, type: DBRetCode, techInfo?: any ) {
      this.message = msg
      this.type = type ?? DBRetCode.ERROR
      this.techInfo = safeToStringLocal( techInfo ) ?? ''

      setTimeout( () => {
        this.message = ''
        this.type = DBRetCode.SUCCESS
        this.techInfo = ''
      }, ERROR_MESSAGE_DELAY )
    } /*
        setError(error: string, errorType?: DBRetCode, techInfo?: any) {
            this.error = error;
            this.type = errorType ?? DBRetCode.ERROR
            this.techInfo=safeToString(techInfo) ?? '';

            setTimeout(() => {
                this.error = '';
                this.type=DBRetCode.SUCCESS
                this.techInfo= '';
            }, ERROR_MESSAGE_DELAY);
        },*/,
    setError ( error: string, techInfo?: any ) {
      if (
        ( techInfo as IntError )?.message !== undefined &&
        ( techInfo as IntError )?.code !== undefined &&
        ( techInfo as IntError )?.functionName !== undefined
      )
      {
        const errorInternal = techInfo as IntError
        //console.log('setError error internal', errorInternal)
        const newTechInfo = {
          error,
          techInfo,
        }
        const i18Error = i18nGlobal.t( 'error.' + errorInternal.code )
        const newDisplayMsg = i18Error !== 'error.' + errorInternal.code ? i18Error : i18nGlobal.t( 'error.default' )
        this.displayMsg( newDisplayMsg, DBRetCode.ERROR, newTechInfo )
      } else
      {
        //console.log('setError error', error)
        this.displayMsg( error, DBRetCode.ERROR, techInfo )
      }
    },
    setSuccess ( msg: string, techInfo?: any ) {
      //console.log('setSuccess msg', msg)
      this.displayMsg( msg, DBRetCode.SUCCESS, techInfo )
    },
  },
} )
